export default function setCareerPageHeaderHeight() {
  const isPresent = document.querySelector("[data-career-header-inner]");
  if (!isPresent) {
    return;
  }

  const careerHeader = document.querySelector("[data-career-header-inner]");
  if (careerHeader) {
    const headerHeight = careerHeader.offsetHeight;
    document.querySelectorAll("[data-set-min-height]").forEach((element) => {
      element.style.minHeight = `${headerHeight + 120}px`;
    });
  }
}
